"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withErrorBoundary = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _errors = require("../../utils/errors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const withErrorBoundary = Component => {
  class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isError: false
      };
    }
    static getDerivedStateFromError() {
      return {
        isError: true
      };
    }
    componentDidCatch(error, errorInfo) {
      this.props.logger.error(new _errors.ChartStaticError({
        domain: 'withErrorBoundary.ts',
        message: error.message,
        details: {
          stack: error.stack,
          componentStack: errorInfo.componentStack
        }
      }));
    }
    render() {
      if (this.state.isError) {
        return this.props.fallback || null;
      }
      return /*#__PURE__*/React.createElement(Component, this.props);
    }
  }
  (0, _defineProperty2.default)(ErrorBoundary, "displayName", `withErrorBoundary(${Component.displayName})`);
  return ErrorBoundary;
};
exports.withErrorBoundary = withErrorBoundary;